module.exports = __webpack_public_path__ + "img/pencil_pink_icon.af4b4f6c.svg";